'use client';
import Alert from '../icons/Alert';
export default function ErrorAddToCartToastBody(error) {
  const errorMessage = error?.error?.message;

  function openChat() {
    const widgetFrame = document?.querySelector('iframe[src*="kodif"]');
    if (widgetFrame && widgetFrame?.contentWindow) {
      widgetFrame.contentWindow.postMessage(
        { type: 'toggle-expanded', isExpanded: true },
        '*'
      );
    }
  }

  return (
    <div className="rounded-md bg-[#F6EFED] pt-2 pr-4 pb-4 pl-4">
      <div className="flex items-start">
        <div className="flex-1 pt-1 pr-9">
          <div className="mb-1 flex items-center">
            {<Alert className="mr-1" />}

            <p className="sh10">Sorry, there was a cart error</p>
          </div>
          <div className="mb-3">
            <p className="body-s">{errorMessage}</p>
          </div>

          <button
            className="btn-s border-parlor-green text-parlor-green hover:border-parlor-green-80 hover:bg-parlor-green-80 block border bg-transparent px-8 py-2 text-center whitespace-nowrap transition-colors duration-150 hover:text-white"
            onClick={openChat}
          >
            Chat with our Comfort Crew
          </button>
        </div>
      </div>
    </div>
  );
}
